import { render, staticRenderFns } from "./NoDataAvailable.vue?vue&type=template&id=3bfcdea8&scoped=true"
import script from "./NoDataAvailable.vue?vue&type=script&lang=ts"
export * from "./NoDataAvailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcdea8",
  null
  
)

export default component.exports